import { getLoginLink } from '@confluence/login-if-anonymous/entry-points/getLoginLink';
import { VIEW_PAGE, VIEW_PAGE_ACTION_LEGACY, WHITEBOARD_BOARD } from '@confluence/named-routes';

import { PRODUCTION_WAC_DOMAIN, STAGING_WAC_DOMAIN } from './constants';

function toViewContentURL(
	contentId: string,
	spaceKey?: string | null,
	contentType?: string | null,
) {
	if (contentType === 'whiteboard') {
		return WHITEBOARD_BOARD.toUrl({ contentId, spaceKey });
	} else {
		// contentType === "page" as default
		if (spaceKey) {
			return VIEW_PAGE.toUrl({ contentId, spaceKey });
		} else {
			return VIEW_PAGE_ACTION_LEGACY.toUrl(
				{},
				{
					query: {
						pageId: contentId,
					},
				},
			);
		}
	}
}

export const getRedirectLink = (
	contentId: string,
	spaceKey?: string | null,
	contentType?: string | null,
) => toViewContentURL(contentId, spaceKey, contentType);

export const getJoinLink = (
	contentId: string,
	cloudId: string,
	spaceKey?: string | null,
	contentType?: string | null,
) => getRequestAccessLink(toViewContentURL(contentId, spaceKey, contentType), cloudId);

const getRequestAccessLink = (requestAccessContinueUrl: string, cloudId: string) =>
	getLoginLink(
		(identity) =>
			`https://${identity}/join/user-access?resource=ari:cloud:confluence::site/${cloudId}&continue=${requestAccessContinueUrl}`,
	);

export const getWacDomain = (environment: string) => {
	return environment === 'PRODUCTION' ? PRODUCTION_WAC_DOMAIN : STAGING_WAC_DOMAIN;
};
